/**
 * D-285 - one rule for a short inline message (a light error next to the thing you pressed): it leaves by itself
 * after ~4 s (the same time a toast stays, see toastStore), hover / focus pauses it, and it has a close button.
 * Messages that need action (D-279's blocking message, a form error inside its form) do NOT use this.
 * Pure timing so a unit test can drive it with fake timers; <TransientAlert> only wires it to React.
 */
export const TRANSIENT_ALERT_MS = 4000;

export interface TransientClock {
  start: () => void;
  stop: () => void;
}

export function createTransientClock(
  onExpire: () => void,
  ms: number = TRANSIENT_ALERT_MS,
  timers: { set: (fn: () => void, ms: number) => unknown; clear: (id: unknown) => void } = {
    set: (fn, t) => setTimeout(fn, t),
    clear: (id) => clearTimeout(id as ReturnType<typeof setTimeout>),
  },
): TransientClock {
  let id: unknown;
  let running = false;
  const stop = () => { if (running) { timers.clear(id); running = false; } };
  return {
    stop,
    start: () => {
      stop();
      id = timers.set(() => { running = false; onExpire(); }, ms);
      running = true;
    },
  };
}
